import { Breadcrumb, Card } from "antd";
import DepositList from "../accounts/components/depositList";
import { useNavigate } from "react-router";
import { ReactComponent as TitleIcon } from "../../assests/images/depositBread.svg";
import { useTranslation } from "react-i18next";
import { ReactComponent as HomeIcon } from "../../assests/images/home-line.svg";

export default function Deposits() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  return (
    <>
        {/* <Breadcrumb separator=">">
          <Breadcrumb.Item>
            <span onClick={() => navigate("/dashboard")}>
              <HomeIcon height={14}/>
            </span>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <span>
              {t("pages.my_accounts.common_my_accounts.deposits", {
                defaultValue: "Deposits",
              })}
            </span>
          </Breadcrumb.Item>
        </Breadcrumb> */}
      <Card size="small" className="mb-1 text-center breadcrumb-title-card">
        <div className="row">
          <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 d-flex justify-content-left align-items-center heading mx-0">
            {/* <TitleIcon height={30} style={{ marginLeft: "-20px" }} /> */}
            <h3 className="title mb-0">
              {t("pages.my_accounts.common_my_accounts.deposits", {
                defaultValue: "Deposits",
              })}
            </h3>
          </div>
        </div>
      </Card>
      <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
        <Card className="dashboard-accounts-body">
          <DepositList />
        </Card>
      </div>
    </>
  );
}
